import { useMemo } from 'react';
import type { ICollection } from '@tacans/shared-marketplace-layer';
import { useIsWebpSupported } from 'src/hooks/use-is-webp-supported';

interface ReturnType {
    avatar?: string;
    avatarRetina?: string;
    banner?: string;
    bannerRetina?: string;
    videoAvatar?: string;
    videoAvatarRetina?: string;
    bannerVideo?: string;
    bannerVideoRetina?: string;
}

export const useCardAssets = ({ collection } : { collection: ICollection }): ReturnType => {
    const isWebp = useIsWebpSupported();

    return useMemo(() => {
        const result: ReturnType = {
            avatar: collection?.previewAssets?.originalUrl,
            banner: collection?.bannerAssets?.originalUrl,
        };

        if (isWebp && collection?.previewAssets?.webps?.smallUrl) {
            result.avatar = collection?.previewAssets?.webps?.smallUrl;
            result.avatarRetina = collection?.previewAssets?.webps?.mediumUrl;
            result.banner = collection?.bannerAssets?.webps?.smallUrl;
            result.bannerRetina = collection?.bannerAssets?.webps?.mediumUrl;
        }
        if (isWebp && collection?.previewAssets?.webps?.mediumUrl) {
            result.banner = collection?.bannerAssets?.webps?.mediumUrl;
            result.bannerRetina = collection?.bannerAssets?.webps?.largeUrl;
        }
        if (collection?.previewAssets?.videos?.smallUrl) {
            result.videoAvatar = collection?.previewAssets?.videos?.smallUrl;
            result.videoAvatarRetina = collection?.previewAssets?.videos?.mediumUrl;
        }
        if (collection?.previewAssets?.videos?.mediumUrl) {
            result.videoAvatar = collection?.previewAssets?.videos?.mediumUrl;
            result.videoAvatarRetina = collection?.previewAssets?.videos?.largeUrl;
        }
        if (collection?.bannerAssets?.videos?.smallUrl) {
            result.bannerVideo = collection?.bannerAssets?.videos?.smallUrl;
            result.bannerVideoRetina = collection?.bannerAssets?.videos?.mediumUrl;
        }
        return result;
    }, [collection, isWebp]);
};
